export default __webpack_public_path__ + "static/media/4.2bd09334.jpg";